export const GET_ORDER_LIST = 'GET_ORDER_LIST';
export const GET_META = 'GET_META';
export const CHANGE_PAGE_COUNT = 'CHANGE_PAGE_COUNT';
export const CHANGE_PULLUP_LOADING = 'CHANGE_PULLUP_LOADING';
export const CHANGE_ALL_LOADING = 'CHANGE_ALL_LOADING';